import moment from 'moment';
import Notifications from 'lib/manage/notifications';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import SubscriberAction from './subscriber_action';

/**
 * This component represents a single row in the notifications subscriber list.
 */
export default class NotificationsSubscriberRow extends React.Component {
  static propTypes = {
    // The expected subscriber shape from the api.
    subscriber: PropTypes.shape({
      id: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      quarantined_at: PropTypes.string,
      purge_at: PropTypes.string,
      mode: PropTypes.oneOf(['email', 'sms', 'webhook']).isRequired,
      email: PropTypes.string,
      endpoint: PropTypes.string,
      phone_number: PropTypes.string,
    }).isRequired,
    state: PropTypes.oneOf(['active', 'unconfirmed', 'quarantined']).isRequired,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      ),
    ]),
    href: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    href: null,
  };

  render() {
    const childrenWithBoundCallbacks = React.Children.map(
      this.props.children,
      child => {
        if (child && child.type === SubscriberAction) {
          // This onClick is the one for links that *do not* rely on the current selection.
          return React.cloneElement(child, {
            onClick: e =>
              child.props.onClick(
                e,
                [this.props.subscriber.id],
                child.props.subscriberState,
              ),
          });
        }
        return child;
      },
    );

    const createdAtColumnSize =
      this.props.state === 'quarantined'
        ? 'created-at-small'
        : 'created-at-large';

    const quarantinedAtAdg3DateFormat = `${moment(
      this.props.subscriber.quarantined_at,
    ).format('DD MMM YYYY')} /
    ${moment(this.props.subscriber.purge_at).format('DD MMM YYYY')}`;

    const quarantineColumn =
      this.props.state === 'quarantined' ? (
        <div className="subscriber-content-column quarantined-at">
          {quarantinedAtAdg3DateFormat}
        </div>
      ) : null;
    const actionsColumnSize =
      this.props.state === 'unconfirmed' ? 'actions-large' : 'actions-small';
    const createdAtDateFormat = moment(this.props.subscriber.created_at).format(
      'DD MMM YYYY',
    );

    const subscriberTitleAdg3 = (
      <div className="subscriber-title-wrapper">
        <div className="subscriber-content-column subscriber-title">
          {
            this.props.subscriber[
              Notifications.SUBSCRIBER_DISPLAY_FIELD_BY_TYPE[
                this.props.subscriber.mode
              ]
            ]
          }
        </div>
      </div>
    );

    return (
      <div className="subscriber-content-columns">
        {subscriberTitleAdg3}
        <div
          className={classnames(
            'subscriber-content-column',
            'created-at',
            createdAtColumnSize,
          )}
        >
          {createdAtDateFormat}
        </div>
        {quarantineColumn}
        <div
          className={classnames(
            'subscriber-content-column',
            'actions',
            actionsColumnSize,
          )}
        >
          {childrenWithBoundCallbacks}
        </div>
      </div>
    );
  }
}
